import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { mobileAppDownloadPath } from 'lib/urls'
import { InfoButton, CloseButton } from 'components/buttons'
import { Wave } from 'components/curves'
import Link from 'components/link'

import css from './app-promo.scss'

export const AppPromoWave = ({ onClose }) => {
  return (
    <>
      <div className={classNames('text-center', css.promoWaveHeader)}>
        <div className={css.promoWaveHeaderEnd}>
          <CloseButton onClick={onClose} />
        </div>
        <div className={`h1 ${css.promoWaveHeading}`}>
          Ready to add any item from any store?
        </div>
      </div>
      <div className={css.promoWaveComponentWrapper}>
        <Wave color="white" />
      </div>
      <div className={classNames('pbxxl text-center')}>
        <InfoButton href={mobileAppDownloadPath()} className="mbl" pill>
          Get The Babylist App
        </InfoButton>
        <p>
          <Link
            onClick={onClose}
            className={classNames('small', css.promoWaveLink)}
          >
            Continue browsing the mobile site
          </Link>
        </p>
      </div>
    </>
  )
}

AppPromoWave.propTypes = {
  onClose: PropTypes.func,
}

AppPromoWave.defaultProps = {
  onClose: () => {},
}

export const AppPromoStartBuilding = () => {
  return (
    <>
      <div className={classNames('text-center', css.promoWaveHeader)}>
        <h1 className={css.promoWaveHeading}>
          Ready to start building your registry?
        </h1>
        <p className={classNames('tiny', css.promoWaveSubHeading)}>
          You'll need our 5-star rated app to add items from any online store
          (from your mobile device).
        </p>
      </div>
      <div className={css.promoWaveComponentWrapperSmall}>
        <Wave color="white" />
      </div>
      <div className={classNames('pbxxl text-center')}>
        <InfoButton href={mobileAppDownloadPath()} className="mbl" pill>
          Get The Babylist App
        </InfoButton>
        <p className={classNames('tiny', css.promeWaveDisclaimerText)}>
          Without the babylist app, you can still add items from the Babylist
          Store and browse the mobile site.
        </p>
      </div>
    </>
  )
}

export const AppPromoNextStep = ({ onClose }) => (
  <>
    <div className={classNames('text-center', css.promoWaveHeader)}>
      <div className={css.promoWaveHeaderEnd}>
        <CloseButton onClick={onClose} />
      </div>
      <h1 className={css.promoWaveHeading}>Next Step: Get The App</h1>
      <p className={classNames('tiny', css.promoWaveSubHeading)}>
        You'll need our 5-star rated app to add items from any online store
        (from your mobile device).
      </p>
    </div>
    <div className={css.promoWaveComponentWrapperSmall}>
      <Wave color="white" />
    </div>
    <div className={classNames('pbxxl text-center')}>
      <InfoButton href={mobileAppDownloadPath()} className="mbl" pill>
        Get The Babylist App
      </InfoButton>
      <p className={classNames('tiny', css.promeWaveDisclaimerText)}>
        Nah, I want to{' '}
        <Link
          onClick={onClose}
          className={classNames('tiny', css.promoWaveLink)}
        >
          browse the mobile site
        </Link>{' '}
        and add items from Babylist Store only.
      </p>
    </div>
  </>
)

export const AppPromoCollaborator = ({ registrantNames }) => {
  return (
    <>
      <div className={classNames('text-center', css.promoWaveHeader)}>
        <h1 className={css.promoWaveHeading}>
          Get the app to help
          <br />
          {registrantNames}
          <br />
          build their registry.
        </h1>
        <p className={classNames('tiny', css.promoWaveSubHeading)}>
          On your phone? You'll need the app.
        </p>
      </div>
      <div className={css.promoWaveComponentWrapperSmall}>
        <Wave color="white" />
      </div>
      <div className={classNames('pbxxl text-center')}>
        <InfoButton href={mobileAppDownloadPath()} className="mbl" pill>
          Get The Babylist App
        </InfoButton>
      </div>
    </>
  )
}

AppPromoNextStep.propTypes = {
  onClose: PropTypes.func,
}

AppPromoNextStep.defaultProps = {
  onClose: () => {},
}
